"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = StaticCompetitorTable;
var _react = _interopRequireWildcard(require("react"));
var _formik = require("formik");
var _reactBlueprintLibrary = require("react-blueprint-library");
var _reactBootstrap = require("react-bootstrap");
var _StaticCompetitorViews = require("./StaticCompetitorViews");
var _GuaranteedLifetimeWithdrawalBenefitWizardCalc = require("./GuaranteedLifetimeWithdrawalBenefitWizardCalc.config");
var _utils = require("../../middleware/utils");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function StaticCompetitorTable(_ref) {
  var {
    setIsEditable,
    setSnapshot,
    arraySelection,
    showToast,
    setShowToast
  } = _ref;
  var {
    values: {
      rollUpRate,
      rollUpPeriod,
      interestRollUp
    },
    values
  } = (0, _formik.useFormikContext)();
  var updatedStaticView = values[arraySelection].map(function (value, index) {
    return /*#__PURE__*/_react.default.createElement("tr", {
      key: index
    }, /*#__PURE__*/_react.default.createElement("td", null, value.startAge, " - ", value.endAge), /*#__PURE__*/_react.default.createElement("td", null, parseFloat(value.withdrawalRate).toFixed(2), "%"));
  });

  // Auto-focus to snap scrolling to top of the stepper/progress bar if user travels back-and-forth between steps
  (0, _react.useEffect)(() => {
    document.getElementById(_GuaranteedLifetimeWithdrawalBenefitWizardCalc.calcName).scrollIntoView();
    /* istanbul ignore else */
    if (window) {
      window.scrollBy(0, -112);
    }
  }, []);
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, showToast ? /*#__PURE__*/_react.default.createElement(ConfirmationToast, {
    setShowToast: setShowToast
  }) : '', /*#__PURE__*/_react.default.createElement("div", {
    className: "col-md-8"
  }, /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Card, null, /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Card.Body, {
    className: "zircon-background"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "row"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "col"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "row justify-content-center"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "col-12 col-md-8"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "row justify-content-center copy-lg mm-spacing--minor"
  }, /*#__PURE__*/_react.default.createElement("strong", null, "Sample Competitor")), /*#__PURE__*/_react.default.createElement("div", {
    className: "glwb-static-competitor-table"
  }, /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.SimpleTable, {
    tableCaption: "Competitor Guaranteed Lifetime Withdrawal Benefit Information Table"
  }, /*#__PURE__*/_react.default.createElement("tbody", {
    className: "mm-text-center"
  }, /*#__PURE__*/_react.default.createElement("tr", null, /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.SimpleTable.HeaderCell, {
    id: "StaticTableAgeRangeHeader"
  }, /*#__PURE__*/_react.default.createElement("strong", null, "Age range")), /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.SimpleTable.HeaderCell, {
    id: "StaticTableWithdrawalRateHeader"
  }, /*#__PURE__*/_react.default.createElement("strong", null, "Withdrawal rate"))), updatedStaticView))))))), /*#__PURE__*/_react.default.createElement("div", {
    className: "row"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "col"
  }, /*#__PURE__*/_react.default.createElement(_StaticCompetitorViews.DesktopView, {
    rollUpRate: rollUpRate,
    rollUpPeriod: rollUpPeriod,
    interestRollUp: interestRollUp
  }), /*#__PURE__*/_react.default.createElement(_StaticCompetitorViews.TabletAndMobileView, {
    rollUpRate: rollUpRate,
    rollUpPeriod: rollUpPeriod,
    interestRollUp: interestRollUp
  }))), /*#__PURE__*/_react.default.createElement("div", {
    className: "mm-spacing--minor"
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "row justify-content-center"
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Button, {
    variant: "none",
    className: "btn-inline",
    onClick: () => {
      (0, _utils.customTealiumEvent)(_GuaranteedLifetimeWithdrawalBenefitWizardCalc.calcName, 'click', 'useDifferentCompetitorInfoButton');
      setIsEditable(true);
      setSnapshot({
        arraySelection: arraySelection,
        value: values[arraySelection]
      });
    }
  }, "Use different competitor information"))))));
}
function ConfirmationToast(_ref2) {
  var {
    setShowToast
  } = _ref2;
  setTimeout(() => {
    setShowToast(false);
  }, 5000);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "mm-toast-container confirmation-toast-spacing"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "toast",
    role: "alert",
    "aria-live": "assertive",
    "aria-atomic": "true"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "wrapper"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "toast-header"
  }, /*#__PURE__*/_react.default.createElement("strong", null, "Competitor information updated!"), /*#__PURE__*/_react.default.createElement("button", {
    type: "button",
    onClick: () => setShowToast(false),
    "data-dismiss": "toast",
    "aria-label": "Close"
  })))));
}